// extracted by mini-css-extract-plugin
export default {"manageModal":"ManageModal_m_styles__manageModal__uToV7","blockingTable":"ManageModal_m_styles__blockingTable__oMHZC"};